import type { RefObject } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

export const executeCaptcha = async (
  captchaRef: RefObject<{
    resetCaptcha: () => void;
    execute: (options: { async: boolean }) => Promise<{ response: string }>;
  }>,
) => {
  try {
    const { response: captchaToken } = await captchaRef.current.execute({
      async: true,
    });
    datadogLogs.logger.info('Captcha executed successfully');
    return captchaToken;
  } catch (error: unknown) {
    datadogLogs.logger.error('Error executing captcha', {}, error as Error);
  } finally {
    if (captchaRef.current) captchaRef.current.resetCaptcha();
  }
};
